/* Contract 11 · the facts the bell counts (lib pack 3, 08/10). One reader for the topbar bell, the
   « Activité & alertes » centre and Accueil's quota line, so the three never disagree (UVP-36: the
   bell said 7 while Messages listed 2). The words of each fact live with the centre that lists them. */
import type { FeedKind, NotificationItem, NotificationsFeed } from './api'
import { currentUser } from './scope'

/** The kinds this app knows how to say (11.1). A kind the server adds later is neither listed nor counted
    until it has its words, so the bell never counts a row the centre cannot show. */
export const FEED_KINDS: readonly FeedKind[] = ['quota_warning', 'quota_paused', 'slice_capped', 'feedback_received', 'campaign_ended', 'prize_cancelled']

const paris = (iso: string, o: Intl.DateTimeFormatOptions) => new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', ...o }).format(new Date(iso))
/** « aujourd’hui 18:04 », « hier 18:04 », else « le 4 octobre à 18:04 » — the merchant's clock (Europe/Paris). */
export function quandParis(iso: string, now = new Date()): string {
  const day = (d: Date | string) => paris(typeof d === 'string' ? d : d.toISOString(), { year: 'numeric', month: '2-digit', day: '2-digit' })
  const at = paris(iso, { hour: '2-digit', minute: '2-digit' })
  if (day(iso) === day(now)) return `aujourd’hui ${at}`
  if (day(iso) === day(new Date(now.getTime() - 864e5))) return `hier ${at}`
  return `le ${paris(iso, { day: 'numeric', month: 'long' })} à ${at}`
}

/** 11.3 · owner and admin read every kind; manager and staff read the retours of their établissements only.
    The API filters; this mirror keeps a mock world telling the same story to a manager. */
export function factsFor(feed?: NotificationsFeed): NotificationItem[] {
  const all = (feed?.items ?? []).filter(i => FEED_KINDS.includes(i.kind))
  const { role } = currentUser()
  return role === 'owner' || role === 'admin' ? all : all.filter(i => i.kind === 'feedback_received')
}

/** The « Activité & alertes » count, which is the bell's share of it: the unread facts the centre resolves.
    A retour is counted once, where it is read (« Retours privés », lib/messages), never twice. */
export const unreadActivite = (items: NotificationItem[]): number =>
  items.filter(i => !i.readAt && i.kind !== 'feedback_received').length

/** N1 · the latest quota fact of the window: the pause (the ceiling) wins over a warning (80 %, 100 %). */
export const quotaFact = (items: NotificationItem[]): NotificationItem | null =>
  items.find(i => i.kind === 'quota_paused') ?? items.find(i => i.kind === 'quota_warning') ?? null
